import { render, staticRenderFns } from "./TrainingProject.vue?vue&type=template&id=7a740f7c&scoped=true&"
import script from "./TrainingProject.vue?vue&type=script&lang=js&"
export * from "./TrainingProject.vue?vue&type=script&lang=js&"
import style0 from "./TrainingProject.vue?vue&type=style&index=0&id=7a740f7c&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/_vue-loader@15.10.0@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7a740f7c",
  null
  
)

export default component.exports